import {GET_ATTENDANCE_OFFSET_DAYS} from './accessible-action-types'
import {SET_AVERAGE_ATTENDANCE_OFFSET} from './accessible-mutation-types'
import server from '../../server'

const state = {
  averageAttendanceOffset: -1
}

const mutations = {
  [SET_AVERAGE_ATTENDANCE_OFFSET] (state, offset) {
    state.averageAttendanceOffset = Math.abs(offset)
  }
}

const actions = {
  [GET_ATTENDANCE_OFFSET_DAYS] ({rootState, commit}) {
    const url = `/core/application_property/attendance_offset`
    const actionData = { action: GET_ATTENDANCE_OFFSET_DAYS }
    server.getReplayable(url, actionData).then(response => {
      commit(SET_AVERAGE_ATTENDANCE_OFFSET, response.data)
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/accessibility/accessibleStudentProfile.js